export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_21.eb695d65.jpg";